import { render, staticRenderFns } from "./ExamineeNoCheatReminder.vue?vue&type=template&id=6421d043&scoped=true&"
import script from "./ExamineeNoCheatReminder.vue?vue&type=script&lang=js&"
export * from "./ExamineeNoCheatReminder.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeNoCheatReminder.vue?vue&type=style&index=0&id=6421d043&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421d043",
  null
  
)

export default component.exports